<template>
  <div>
    <div id="myAccountJm" class="modal fade sharkbet-jm-modal sharkbet-game-history-modal" tabindex="-1" aria-hidden="true" data-bs-backdrop="false">
      <div class="modal-dialog modal-lg modal-dialog-centered"><div class="modal-content">
        <button type="button" class="sharkbet-history-modal__close" data-bs-dismiss="modal" aria-label="Cerrar"><i class="fas fa-times" aria-hidden="true"></i></button>
        <div class="modal-body"><game-history variant="mobile" /></div>
      </div></div>
    </div>

    <div id="sharkbetTransactions" class="modal fade sharkbet-jm-modal sharkbet-transactions-modal" tabindex="-1" aria-hidden="true" data-bs-backdrop="false">
      <div class="modal-dialog modal-lg modal-dialog-centered"><div class="modal-content">
        <button type="button" class="sharkbet-transactions-modal__close" data-bs-dismiss="modal" aria-label="Cerrar"><i class="fas fa-times" aria-hidden="true"></i></button>
        <div class="modal-body"><transactions variant="mobile" /></div>
      </div></div>
    </div>

    <div id="sharkbetBonuses" class="modal fade sharkbet-jm-modal sharkbet-bonuses-modal" tabindex="-1" aria-hidden="true" data-bs-backdrop="false">
      <div class="modal-dialog modal-lg modal-dialog-centered"><div class="modal-content">
        <button type="button" class="sharkbet-bonuses-modal__close" data-bs-dismiss="modal" aria-label="Cerrar"><i class="fas fa-times" aria-hidden="true"></i></button>
        <div class="modal-body"><bonuses variant="mobile" /></div>
      </div></div>
    </div>

    <div id="historial_ingresos" class="modal fade sharkbet-jm-modal sharkbet-income-history-modal" tabindex="-1" aria-hidden="true" data-bs-backdrop="false">
      <div class="modal-dialog modal-lg modal-dialog-centered"><div class="modal-content">
        <button type="button" class="sharkbet-history-modal__close" data-bs-dismiss="modal" aria-label="Cerrar"><i class="fas fa-times" aria-hidden="true"></i></button>
        <div class="modal-body"><income-history variant="mobile" /></div>
      </div></div>
    </div>

    <div id="changePasswordJm" class="modal fade sharkbet-jm-modal sharkbet-jm-password-modal" tabindex="-1" aria-hidden="true" data-bs-backdrop="false">
      <div class="modal-dialog modal-sm modal-dialog-centered"><div class="modal-content">
        <button type="button" class="sharkbet-jm-password-modal__close" data-bs-dismiss="modal" aria-label="Cerrar"><i class="fas fa-times" aria-hidden="true"></i></button>
        <div class="modal-body">
          <h2>CAMBIAR CONTRASEÑA</h2>
          <form class="sharkbet-jm-password-modal__form" @submit.prevent="changePassword">
            <label>Contraseña actual *
              <span class="sharkbet-jm-password-modal__input">
                <i class="fas fa-lock" aria-hidden="true"></i>
                <input v-model="currentPassword" :type="showCurrentPassword ? 'text' : 'password'" autocomplete="current-password" required>
                <button type="button" aria-label="Mostrar contraseña actual" @click="showCurrentPassword = !showCurrentPassword"><i :class="showCurrentPassword ? 'fas fa-eye-slash' : 'fas fa-eye'" aria-hidden="true"></i></button>
              </span>
            </label>
            <label>Nueva contraseña *
              <span class="sharkbet-jm-password-modal__input">
                <i class="fas fa-lock" aria-hidden="true"></i>
                <input v-model="password" :type="showPassword ? 'text' : 'password'" autocomplete="new-password" required>
                <i class="fas fa-info-circle sharkbet-jm-password-modal__help" title="Usa una contraseña segura" aria-hidden="true"></i>
                <button type="button" aria-label="Mostrar nueva contraseña" @click="showPassword = !showPassword"><i :class="showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'" aria-hidden="true"></i></button>
              </span>
            </label>
            <label>Repetir contraseña *
              <span class="sharkbet-jm-password-modal__input">
                <i class="fas fa-lock" aria-hidden="true"></i>
                <input v-model="password2" :type="showRepeatPassword ? 'text' : 'password'" maxlength="16" autocomplete="new-password" required>
                <i class="fas fa-info-circle sharkbet-jm-password-modal__help" title="Repite la nueva contraseña" aria-hidden="true"></i>
                <button type="button" aria-label="Mostrar confirmación de contraseña" @click="showRepeatPassword = !showRepeatPassword"><i :class="showRepeatPassword ? 'fas fa-eye-slash' : 'fas fa-eye'" aria-hidden="true"></i></button>
              </span>
            </label>
            <div class="sharkbet-jm-password-modal__actions"><button type="submit" :disabled="changingPassword || !canChangePassword">{{ changingPassword ? 'Cambiando contraseña' : 'Cambiar contraseña' }}</button><button type="button" :disabled="changingPassword" @click="resetPasswordForm">Restablecer</button></div>
          </form>
          <div v-if="passwordStatus.message" :class="`alert alert-${passwordStatus.type}`">{{ passwordStatus.message }}</div>
        </div>
      </div></div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import Bonuses from './bonuses.vue';
import GameHistory from './game_history.vue';
import IncomeHistory from './income_history.vue';
import Transactions from './transactions.vue';

export default {
  name: 'SharkbetJmAccountModals',
  props: ['translation', 'language'],
  components: { Bonuses, GameHistory, IncomeHistory, Transactions },
  data() {
    return {
      changingPassword: false, currentPassword: '', password: '', password2: '', passwordStatus: { message: '', type: '' },
      showCurrentPassword: false, showPassword: false, showRepeatPassword: false,
    };
  },
  computed: {
    apiUrl() { return this.$store.getters['getApiUrlnew']; },
    user() { return this.$store.getters['getUserData']; },
    canChangePassword() { return Boolean(this.currentPassword && this.password && this.password2); },
  },
  methods: {
    async changePassword() {
      if (this.password !== this.password2) {
        this.passwordStatus = { message: 'Las contraseñas no coinciden', type: 'danger' };
        return;
      }
      this.changingPassword = true;
      this.passwordStatus = { message: '', type: '' };
      try {
        const id = this.user.user_data.data.user_id ?? this.user.user_data.data.id;
        const response = await axios.post(`${this.apiUrl}user/cambiar_password`, { users: [id], password: this.password, password1: this.password2, login_id: id }, { headers: { 'x-player-token': this.user.token, 'x-api-key': 'FTBBW4bR1pKTUFsURbFD8RpcPygh8wN6' } });
        if (response.data.error) this.passwordStatus = { message: response.data.error, type: 'danger' };
        else {
          this.passwordStatus = { message: response.data.message, type: 'success' };
          this.$store.dispatch('logOut');
          this.$root.$emit('forceRender');
        }
      } catch (error) { this.passwordStatus = { message: error.response?.data?.error || 'Error', type: 'danger' }; }
      finally { this.changingPassword = false; }
    },
    resetPasswordForm() {
      if (this.changingPassword) return;
      this.currentPassword = '';
      this.password = '';
      this.password2 = '';
      this.passwordStatus = { message: '', type: '' };
      this.showCurrentPassword = false;
      this.showPassword = false;
      this.showRepeatPassword = false;
    },
    translate(text) { return this.translation[text]?.[this.language] || this.translation[text.replace(/ /g, '_')]?.[this.language] || text; },
  },
};
</script>

<style scoped>
.sharkbet-jm-modal { background: rgba(0, 0, 0, .58); }
.modal-content { background: #061823; border: 1px solid #0092cd; color: #fff; }
.modal-header { align-items: center; background: linear-gradient(100deg, #0092cd, #00648d); border: 0; color: #fff; padding: 14px 20px; }
.modal-header h6 { font: 700 17px 'Exo 2', sans-serif; margin: 0; }
.sharkbet-jm-modal__close { background: transparent; border: 0; color: #fff; font-size: 18px; }
.sharkbet-jm-modal__loading { color: #00b6ff; padding: 28px; text-align: center; }
.sharkbet-jm-modal__table { color: #fff; font-size: 14px; }
.sharkbet-jm-modal__table th { border-color: rgba(0, 146, 205, .35); color: #00b6ff; font-weight: 600; }
.sharkbet-jm-modal__table td { border-color: rgba(255, 255, 255, .1); }
.sharkbet-jm-modal__pagination { align-items: center; display: flex; gap: 12px; justify-content: flex-end; margin: 8px 0 24px; }
.sharkbet-jm-modal__pagination button, .sharkbet-jm-modal__button { background: #0092cd; border: 0; border-radius: 4px; color: #fff; padding: 6px 12px; }
.sharkbet-jm-modal__pagination button:disabled { cursor: not-allowed; opacity: .45; }
.sharkbet-jm-modal__field { align-items: center; border-bottom: 1px solid rgba(255, 255, 255, .45); display: flex; margin: 18px 0; }
.sharkbet-jm-modal__field button { background: transparent; border: 0; color: #00b6ff; padding: 6px; }
.sharkbet-jm-modal__field input { background: transparent; border: 0; color: #fff; outline: 0; padding: 8px; width: 100%; }
.sharkbet-jm-modal__actions { display: flex; gap: 10px; margin-top: 24px; }
.sharkbet-jm-modal__actions button { background: #00648d; border: 0; border-radius: 4px; color: #fff; flex: 1; padding: 9px; }
.sharkbet-jm-modal__actions button[type='submit'] { background: #0092cd; }
.alert { margin-top: 16px; }

.sharkbet-game-history-modal .modal-dialog { max-width: 760px; }
.sharkbet-game-history-modal .modal-content { background: #fff; border: 0; border-radius: 12px; position: relative; }
.sharkbet-game-history-modal .modal-body { padding: 24px; }
.sharkbet-transactions-modal .modal-dialog { max-width: 860px; }
.sharkbet-transactions-modal .modal-content { background: #fff; border: 0; border-radius: 12px; position: relative; }
.sharkbet-transactions-modal .modal-body { padding: 24px; }
.sharkbet-transactions-modal__close { align-items: center; background: transparent; border: 0; color: #4d5861; cursor: pointer; display: flex; font-size: 20px; height: 36px; justify-content: center; padding: 0; position: absolute; right: 10px; top: 8px; width: 36px; z-index: 2; }
.sharkbet-bonuses-modal .modal-dialog { max-width: 860px; }
.sharkbet-bonuses-modal .modal-content { background: #fff; border: 0; border-radius: 12px; position: relative; }
.sharkbet-bonuses-modal .modal-body { padding: 24px; }
.sharkbet-bonuses-modal__close { align-items: center; background: transparent; border: 0; color: #4d5861; cursor: pointer; display: flex; font-size: 20px; height: 36px; justify-content: center; padding: 0; position: absolute; right: 10px; top: 8px; width: 36px; z-index: 2; }
.sharkbet-income-history-modal .modal-dialog { max-width: 760px; }
.sharkbet-income-history-modal .modal-content { background: #fff; border: 0; border-radius: 12px; position: relative; }
.sharkbet-income-history-modal .modal-body { padding: 24px; }
.sharkbet-history-modal__close { align-items: center; background: transparent; border: 0; color: #4d5861; cursor: pointer; display: flex; font-size: 20px; height: 36px; justify-content: center; padding: 0; position: absolute; right: 10px; top: 8px; width: 36px; z-index: 2; }

.sharkbet-jm-password-modal .modal-dialog { max-width: 500px; }
.sharkbet-jm-password-modal .modal-content { background: #fff; border: 0; border-radius: 12px; color: #17212a; position: relative; }
.sharkbet-jm-password-modal .modal-body { padding: 26px 16px 32px; }
.sharkbet-jm-password-modal__close { align-items: center; background: transparent; border: 0; color: #4d5861; cursor: pointer; display: flex; font-size: 20px; height: 36px; justify-content: center; padding: 0; position: absolute; right: 8px; top: 8px; width: 36px; z-index: 2; }
.sharkbet-jm-password-modal h2 { font: 400 30px 'Roboto', sans-serif; margin: 0 0 56px; }
.sharkbet-jm-password-modal__form { display: grid; gap: 26px; }
.sharkbet-jm-password-modal__form label { display: grid; font: 500 16px 'Roboto', sans-serif; gap: 6px; }
.sharkbet-jm-password-modal__input { align-items: center; border: 1px solid #c8c8c8; border-radius: 22px; display: flex; height: 40px; padding: 0 12px; }
.sharkbet-jm-password-modal__input:focus-within { border-color: #009fe3; }
.sharkbet-jm-password-modal__input > i { color: #777; flex: 0 0 18px; text-align: center; }
.sharkbet-jm-password-modal__input input { background: transparent; border: 0; color: #17212a; height: 38px; outline: 0; padding: 0 10px; width: 100%; }
.sharkbet-jm-password-modal__input button { background: transparent; border: 0; color: #777; cursor: pointer; padding: 0 2px; }
.sharkbet-jm-password-modal__input button i { font-size: 18px; }
.sharkbet-jm-password-modal__help { margin-left: auto; }
.sharkbet-jm-password-modal__actions { display: grid; gap: 32px; grid-template-columns: 1fr 1fr; margin-top: 4px; }
.sharkbet-jm-password-modal__actions button { border-radius: 22px; cursor: pointer; font: 600 14px 'Roboto', sans-serif; height: 37px; }
.sharkbet-jm-password-modal__actions button[type='submit'] { background: #0092cd; border: 0; color: #fff; }
.sharkbet-jm-password-modal__actions button[type='submit']:disabled { background: #dedede; color: #a4a4a4; cursor: not-allowed; }
.sharkbet-jm-password-modal__actions button[type='button'] { background: #fff; border: 1px solid #009fe3; color: #008ccd; }

@media (max-width: 600px) {
  .sharkbet-game-history-modal .modal-dialog { margin: 12px; }
  .sharkbet-game-history-modal .modal-body { padding: 18px; }
  .sharkbet-transactions-modal .modal-dialog { margin: 12px; }
  .sharkbet-transactions-modal .modal-body { padding: 18px; }
  .sharkbet-bonuses-modal .modal-dialog { margin: 12px; }
  .sharkbet-bonuses-modal .modal-body { padding: 18px; }
  .sharkbet-income-history-modal .modal-dialog { margin: 12px; }
  .sharkbet-income-history-modal .modal-body { padding: 18px; }
  .sharkbet-jm-password-modal .modal-dialog { margin: 24px; }
  .sharkbet-jm-password-modal .modal-body { padding: 26px 16px 32px; }
}
</style>
